export const LOAD_POLICIES_LIST = 'LOAD_POLICIES_LIST'
export const LOAD_POLICIES_LIST_FULFILLED = 'LOAD_POLICIES_LIST_FULFILLED'
export const LOAD_POLICIES_LIST_PENDING = 'LOAD_POLICIES_LIST_PENDING'
export const LOAD_POLICIES_LIST_REJECTED = 'LOAD_POLICIES_LIST_REJECTED'

export const GET_POLICY_MEMBERS = 'GET_POLICY_MEMBERS'
export const GET_POLICY_MEMBERS_PENDING = 'GET_POLICY_MEMBERS_PENDING'
export const GET_POLICY_MEMBERS_FULFILLED = 'GET_POLICY_MEMBERS_FULFILLED'
export const GET_POLICY_MEMBERS_REJECTED = 'GET_POLICY_MEMBERS_REJECTED'

export const GET_ELIGIBLE_EMPLOYEE_POLICIES = 'GET_ELIGIBLE_EMPLOYEE_POLICIES'
export const GET_ELIGIBLE_EMPLOYEE_POLICIES_PENDING = 'GET_ELIGIBLE_EMPLOYEE_POLICIES_PENDING'
export const GET_ELIGIBLE_EMPLOYEE_POLICIES_FULFILLED = 'GET_ELIGIBLE_EMPLOYEE_POLICIES_FULFILLED'
export const GET_ELIGIBLE_EMPLOYEE_POLICIES_REJECTED = 'GET_ELIGIBLE_EMPLOYEE_POLICIES_REJECTED'

export const GET_POLICY_DETAILS = 'GET_POLICY_DETAILS'
export const GET_POLICY_DETAILS_PENDING = 'GET_POLICY_DETAILS_PENDING'
export const GET_POLICY_DETAILS_FULFILLED = 'GET_POLICY_DETAILS_FULFILLED'
export const GET_POLICY_DETAILS_REJECTED = 'GET_POLICY_DETAILS_REJECTED'

export const GET_MEMBER_DETAILS = 'GET_MEMBER_DETAILS'
export const GET_MEMBER_DETAILS_PENDING = 'GET_MEMBER_DETAILS_PENDING'
export const GET_MEMBER_DETAILS_FULFILLED = 'GET_MEMBER_DETAILS_FULFILLED'
export const GET_MEMBER_DETAILS_REJECTED = 'GET_MEMBER_DETAILS_REJECTED'

export const SYNC_POLICIES = 'SYNC_POLICIES'
export const SYNC_POLICIES_PENDING = 'SYNC_POLICIES_PENDING'
export const SYNC_POLICIES_FULFILLED = 'SYNC_POLICIES_FULFILLED'
export const SYNC_POLICIES_REJECTED = 'SYNC_POLICIES_REJECTED'

export const SYNC_MEMBERS = 'SYNC_MEMBERS'
export const SYNC_MEMBERS_PENDING = 'SYNC_MEMBERS_PENDING'
export const SYNC_MEMBERS_FULFILLED = 'SYNC_MEMBERS_FULFILLED'
export const SYNC_MEMBERS_REJECTED = 'SYNC_MEMBERS_REJECTED'

export const RESET_MEMBER_DETAILS = 'RESET_MEMBER_DETAILS'
